// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3hFEm","content":"Consent_content__3DtHP","footer":"Consent_footer__kpq-C"};